import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { isoWebPageURL } from "../../models/nominals";
import { Link } from "../Link";

type IBreadcrumbItem = Immutable<{
    title: string;
    url?: string | null;
    isCurrentPage?: boolean;
    isTruncated?: boolean;
}>;

type IProps = Immutable<{
    items: readonly IBreadcrumbItem[];
    className?: string;
    useCappedWidth?: boolean;
    wrapperClassName?: string;
    children?: React.ReactNode;
}>;

export const TempurLoveBreadcrumbs = (props: IProps): React.JSX.Element => {
    const useCappedWidth = props.useCappedWidth ?? true;
    const wrapperClass = props.wrapperClassName
        ? `l-full-width ${props.wrapperClassName}`
        : "l-full-width";

    const breadcrumbContent = (
        <div
            className={`sub-nav ${props.className || "al-tlovegrid-breadcrumbs"}`}
        >
            <nav className="breadcrumb" aria-label={t`breadcrumbs`}>
                <ul className="breadcrumb__list">
                    {props.items.map((item, idx) => (
                        <li
                            key={item.url || `breadcrumb-${idx}`}
                            className={
                                item.isTruncated
                                    ? "breadcrumb__list-item breadcrumb__list-item--truncated"
                                    : "breadcrumb__list-item"
                            }
                            aria-current={
                                item.isCurrentPage ? "page" : undefined
                            }
                        >
                            {item.url ? (
                                <Link href={isoWebPageURL.wrap(item.url)}>
                                    {item.title}
                                </Link>
                            ) : (
                                <span>{item.title}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
            {props.children}
        </div>
    );

    if (useCappedWidth) {
        return (
            <div className={wrapperClass}>
                <div className="l-capped-width">{breadcrumbContent}</div>
            </div>
        );
    }

    return <div className={wrapperClass}>{breadcrumbContent}</div>;
};
